import { DisplayConfig } from '../interfaces/Types';

export const displayConfig: DisplayConfig[] = [
  {
    product: 'car',
    rules: [
      {
        packageCode: 'CAR_PACK_001',
        excludedQuestions: [],
        excludedAdditionalPackages: []
      },
      {
        packageCode: 'CAR_PACK_002',
        excludedQuestions: ['Q005'],
        excludedAdditionalPackages: []
      },
      {
        packageCode: 'CAR_PACK_003',
        excludedQuestions: ['Q003', 'Q004', 'Q005'],
        excludedAdditionalPackages: ['CAR_PACK_004']
      }
    ]
  },
  {
    product: 'home',
    rules: [
      {
        packageCode: 'HOME_PACK_001',
        excludedQuestions: ['Q004'],
        excludedAdditionalPackages: []
      },
      {
        packageCode: 'HOME_PACK_002',
        excludedQuestions: ['Q004'],
        excludedAdditionalPackages: []
      },
      {
        packageCode: 'HOME_PACK_003',
        excludedQuestions: ['Q004'],
        excludedAdditionalPackages: []
      }
    ]
  }
];
